import React, { PropsWithChildren } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import classNames from "classnames";

import { Button } from "./toolbar.styles";

interface IProps {
  active?: boolean;
  disabled?: boolean;
  title: string;
  tooltip?: string;
  subtitle?: string;
  variant?: "minimal" | "full";
  onClick(): void;
}

const ToolbarButton: React.FC<PropsWithChildren<IProps>> = ({
  active = false,
  disabled = false,
  children,
  title,
  tooltip = title,
  subtitle,
  variant = "minimal",
  onClick,
  ...props
}: PropsWithChildren<IProps>) => {
  const button = (
    <Button
      className={classNames({ "Mui-selected": active, "variant-full": variant === "full" })}
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
      {...props}
    >
      {variant === "minimal" ? (
        children
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{children}</Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 0 }}>
            <Typography variant="body3" sx={{ fontWeight: 500, lineHeight: 1.4, display: "block" }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontSize: 11, lineHeight: 1.4, color: (theme) => theme.palette.biarri.secondary.grey }}>{subtitle}</Typography>
            )}
          </Box>
        </Box>
      )}
    </Button>
  );

  return variant === "minimal" ? (
    <Tooltip title={tooltip} placement="right">
      <span>{button}</span>
    </Tooltip>
  ) : (
    <span>{button}</span>
  );
};

export default ToolbarButton;
